import { useLocation } from 'react-router'

export function useCheckPrevPathname(prevPathname: string | string[]) {
  const location = useLocation()

  if (!location.state?.prevPathname) {
    return false
  }

  if (typeof prevPathname === 'string') {
    return location.state?.prevPathname !== prevPathname
  }

  return prevPathname.includes(location.state?.prevPathname)
}
